import { Collection } from "../models/collection";

// The URI to display for a collection's own cover image. Preference order mirrors
// recipeImageUri: freshly-picked local pick (pending upload) → offline cache of
// the remote image → the canonical remote URL. Returns undefined when the
// collection has no custom image, so callers can fall back (e.g. to the first
// recipe's image) or render a placeholder.
export function collectionImageUri(
  collection?: Pick<
    Collection,
    "image" | "localImageUri" | "imagePendingUpload" | "cachedImageUri"
  > | null,
): string | undefined {
  if (collection?.imagePendingUpload && collection.localImageUri) {
    return collection.localImageUri;
  }
  if (collection?.cachedImageUri) return collection.cachedImageUri;
  return collection?.image || undefined;
}
